import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from '@emotion/styled';
const BubbleContainer = styled.div`
  display: flex;
  justify-content: ${(props)=>props.isOwn ? 'flex-end' : 'flex-start'};
  margin-bottom: 12px;
  width: 100%;
`;
const BubbleWrapper = styled.div`
  max-width: 70%;
  display: flex;
  flex-direction: column;
  align-items: ${(props)=>props.isOwn ? 'flex-end' : 'flex-start'};

  @media (max-width: 768px) {
    max-width: 85%;
  }
`;
const Bubble = styled.div`
  background-color: ${(props)=>props.isOwn ? '#007bff' : '#f0f0f0'};
  color: ${(props)=>props.isOwn ? '#fff' : '#333'};
  padding: 10px 14px;
  border-radius: 18px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
`;
const SenderName = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #666;
  margin-bottom: 4px;
  padding: 0 4px;
`;
const MessageContent = styled.div`
  font-size: 15px;
  line-height: 1.4;
  white-space: pre-wrap;
`;
const MessageMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  font-size: 11px;
  color: #999;
  padding: 0 4px;
`;
const Timestamp = styled.span`
  font-size: 11px;
`;
const ReadStatus = styled.span`
  font-size: 11px;
  color: #007bff;
`;
const MediaAttachment = styled.div`
  margin-top: 8px;
  max-width: 100%;

  img {
    max-width: 100%;
    border-radius: 12px;
    cursor: pointer;
  }
`;
/**
 * MessageBubble Component
 * Displays a single message bubble with sender info, timestamp, and read status
 */ export const MessageBubble = ({ message, isOwn })=>{
    const formatTimestamp = (timestamp)=>{
        const date = typeof timestamp === 'string' ? new Date(timestamp) : timestamp;
        const now = new Date();
        const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);
        if (diffInSeconds < 60) return 'Just now';
        if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m ago`;
        if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)}h ago`;
        return date.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });
    };
    return /*#__PURE__*/ _jsx(BubbleContainer, {
        isOwn: isOwn,
        "data-testid": "message-bubble-container",
        children: /*#__PURE__*/ _jsxs(BubbleWrapper, {
            isOwn: isOwn,
            children: [
                !isOwn && message.sender && /*#__PURE__*/ _jsx(SenderName, {
                    "data-testid": "message-sender-name",
                    children: message.sender.displayName || 'Unknown User'
                }),
                /*#__PURE__*/ _jsx(Bubble, {
                    isOwn: isOwn,
                    "data-testid": "message-bubble",
                    children: /*#__PURE__*/ _jsx(MessageContent, {
                        "data-testid": "message-content",
                        children: message.text
                    })
                }),
                /*#__PURE__*/ _jsx(MessageMeta, {
                    isOwn: isOwn,
                    children: /*#__PURE__*/ _jsx(Timestamp, {
                        "data-testid": "message-timestamp",
                        children: formatTimestamp(message.timestamp)
                    })
                })
            ]
        })
    });
};
